<template>
  <div>
    <nav class="navbar navbar-expand-lg mb-4" style="position: fixed; top: 0; width: 100%; z-index: 1000; background-color: #F0F0F0;" v-if="showNavbar">
      <div class="container-fluid">
        <router-link class="navbar-brand" to="/">
          <div class="logo navbar-logo" alt="gestion360"></div>
        </router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <!-- Menú dinámico basado en _MenuList del usuario -->
          <DynamicMenu />

          <!-- Menú de usuario -->
          <ul class="navbar-nav ms-auto">
            <li class="nav-item dropdown" v-if="isAuthenticated">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-person-circle me-1"></i>{{ currentUser?.Usuario?._UsuarioMo?.Nombre || 'Usuario' }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li><span class="dropdown-item-text text-muted">{{ currentUser?.Usuario?._UsuarioMo?.UsuarioId || '' }}
                </span></li>
                <li>
                  <router-link to="/perfil" class="dropdown-item">
                    <i class="bi bi-person-badge me-1"></i>Mi Perfil
                  </router-link>
                </li>
                <!-- Selector de temas -->
                <li><hr class="dropdown-divider"></li>
                <li>
                  <span class="dropdown-item-text text-muted small">
                    <i class="bi bi-palette me-1"></i>Tema
                  </span>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="cambiarTema('blue')" :class="{ 'active': temaActual === 'blue' }">
                    <i class="bi bi-circle-fill me-2" style="color: var(--primary-color);"></i>Azul
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="cambiarTema('light')" :class="{ 'active': temaActual === 'light' }">
                    <i class="bi bi-sun-fill me-2" style="color: #ffc107;"></i>Claro
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="cambiarTema('dark')" :class="{ 'active': temaActual === 'dark' }">
                    <i class="bi bi-moon-fill me-2" style="color: #6c757d;"></i>Oscuro
                  </a>
                </li>
                <!-- Nueva sección de empresa -->
                <li v-if="selectedEmpresa"><hr class="dropdown-divider"></li>
                <li v-if="selectedEmpresa">
                  <span class="dropdown-item-text">
                    <i class="bi bi-building me-1 text-primary"></i>
                    <strong>{{ selectedEmpresa.Nombre }}</strong>
                    <br>
                    <small class="text-muted">Código: {{ selectedEmpresa.EmpresaId }}</small>
                  </span>
                </li>
                <li v-if="hasMultipleEmpresas">
                  <a class="dropdown-item" href="#" @click.prevent="showEmpresaSelector">
                    <i class="bi bi-arrow-repeat me-1"></i>Cambiar Empresa
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li><a class="dropdown-item" href="#" @click.prevent="handleLogout">
                  <i class="bi bi-box-arrow-right me-1"></i>Cerrar sesión
                </a></li>
              </ul>
            </li>
            <li class="nav-item" v-else>
              <router-link class="nav-link" to="/login">
                <i class="bi bi-box-arrow-in-right me-1"></i>Iniciar sesión
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Barra de título global -->
    <div class="title-bar" v-if="showNavbar" >
      <div class="container-fluid">
        <div class="d-flex align-items-center">
          <i :class="currentRouteInfo.icon" class="me-2"></i>
          <h5 class="mb-0 fw-bold">{{ currentRouteInfo.title }}</h5>
          <span class="ms-auto small">{{ currentRouteInfo.breadcrumb }}</span>
        </div>
      </div>
    </div>



    <div class="container" :style="pageContainerStyle">
    <!-- Selector de empresa modal -->
    <EmpresaSelector
      v-if="showSelector"
      @empresa-selected="onEmpresaSelected"
      @close="showSelector = false"
    />

    <router-view @toolbar-mounted="onToolbarMounted" />
  </div>
  </div>
  <footer class="text-center py-3 mt-4" v-if="showNavbar">
    <div class="container">
      <p class="mb-0">Copyright © 2023 desarrollado por sistemas tangente del norte tangentemexico.com</p>
    </div>
  </footer>
</template>

<style>
.navbar-brand {
  font-weight: bold;
}

.navbar-nav .nav-link {
  color: #333;
}

.navbar-nav .nav-link:hover {
  color: #007bff;
}

.dropdown-menu {
  border: 1px solid #ddd;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Estilos para hacer el dropdown scrollable en resoluciones pequeñas */
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Media query para pantallas pequeñas */
@media (max-height: 600px) {
  .dropdown-menu {
    max-height: 50vh;
  }
}

@media (max-height: 480px) {
  .dropdown-menu {
    max-height: 40vh;
  }
}

/* Asegurar que el dropdown se posicione correctamente */
.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  z-index: 1000;
  min-width: 200px;
}

/* Estilos para el scroll personalizado */
.dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.theme-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.theme-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #ddd;
}

.theme-color.azul {
  background-color: #007bff;
}

.theme-color.claro {
  background-color: #ffc107;
}

.theme-color.oscuro {
  background-color: #343a40;
}

.empresa-info {
  border-top: 1px solid #eee;
  padding-top: 8px;
  margin-top: 8px;
  font-size: 0.9em;
  color: #666;
}

.empresa-info strong {
  color: #333;
}

/* Asegurar que el botón de cerrar sesión siempre sea visible */
.dropdown-item.text-danger {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  border-top: 1px solid #eee;
  margin-top: auto;
}
</style>

<script>
import authService from '@/shared/services/auth'
import DynamicMenu from '@/shared/components/DynamicMenu.vue'
import EmpresaSelector from '@/shared/components/EmpresaSelector.vue'
import { getRouteTitle } from './utils/route-titles.js'
import { useTheme } from './composables/useTheme'

export default {
  name: 'App',
  components: {
    DynamicMenu,
    EmpresaSelector
  },
  data() {
    return {
      isAuthenticated: false,
      currentUser: null,
      selectedEmpresa: null,
      showSelector: false,
      temaActual: 'blue', // Tema por defecto
      hasToolbar: false // Variable reactiva para detectar toolbar
    };
  },
  computed: {
    hasMultipleEmpresas() {
      if (!this.currentUser?.Usuario?._UsuarioMo?._EmpresaList) return false;
      const empresasActivas = this.currentUser.Usuario._UsuarioMo._EmpresaList.filter(emp => emp.EsActivo === true);
      return empresasActivas.length > 1;
    },
    showNavbar() {
      // Ocultar la barra de navegación en la ruta /login
      return this.$route.path !== '/login';
    },
    currentRouteInfo() {
      // Obtener información de la ruta actual para mostrar en la barra de título
      return getRouteTitle(this.$route.path);
    },
    pageContainerStyle() {
      // Ajustar el margen superior para acomodar navbar + barra de título
      const navbarHeight = 56; // Altura del navbar
      const buttonBarHeight = 42; // Altura de la barra de botones
      const titleBarHeight = 48; // Altura de la barra de título

      // Usar la variable reactiva hasToolbar
      const bbh = this.hasToolbar ? buttonBarHeight : 0;

      return {
        marginTop: `${navbarHeight + bbh + titleBarHeight}px`
      };
    }
  },
  created() {
    // Inicializar tema y obtener el tema actual
    const { currentTheme, cambiarTema } = useTheme();
    this.temaActual = currentTheme.value;
    this.cambiarTemaFn = cambiarTema;
    
    // Verificar estado de autenticación al cargar la aplicación
    this.checkAuth();

    // Escuchar cambios de ruta para verificar autenticación
    this.$router.beforeEach((to, from, next) => {
      // Actualizar estado de autenticación
      this.checkAuth();

      // Si la ruta requiere autenticación y el usuario no está autenticado
      if (to.meta.requiresAuth && !this.isAuthenticated) {
        // Redirigir a la página de login
        next('/login');
      } else {
        // Continuar navegación normal
        next();
      }
    });


  },
  methods: {
    checkAuth() {
      this.isAuthenticated = authService.isAuthenticated();

      if (this.isAuthenticated) {
        this.currentUser = authService.getUser();
        this.selectedEmpresa = authService.getSelectedEmpresa();
        console.log('Usuario autenticado:', this.currentUser);
        console.log('Empresa seleccionada:', this.selectedEmpresa);
      } else {
        this.selectedEmpresa = null;
      }
    },
    showEmpresaSelector() {
      this.showSelector = true;
    },
    onEmpresaSelected(empresa) {
      this.selectedEmpresa = empresa;
      this.showSelector = false;
      // Recargar la página para actualizar el menú con la nueva empresa
      window.location.reload();
    },
    cambiarTema(nuevoTema) {
      // Cambiar el tema usando el composable
      this.cambiarTemaFn(nuevoTema);
      // Actualizar el tema actual en el componente
      this.temaActual = nuevoTema;
    },

    async handleLogout() {
      try {
        // Mostrar indicador de carga o deshabilitar botón si es necesario

        // Cerrar sesión del usuario (ahora es asíncrono)
        await authService.logout();

        // Actualizar estado
        this.isAuthenticated = false;
        this.currentUser = null;
        this.selectedEmpresa = null;

        // Redirigir a la página de login
        this.$router.push('/login');
      } catch (error) {
        console.error('Error al cerrar sesión:', error);
        // Continuar con el cierre de sesión local aunque falle el registro en el backend
        this.isAuthenticated = false;
        this.currentUser = null;
        this.selectedEmpresa = null;
        this.$router.push('/login');
      }
    },

    onToolbarMounted() {
      // Método para manejar el evento toolbar-mounted
      this.hasToolbar = true;
    }

  },
  watch: {
    // Resetear hasToolbar cuando cambie la ruta
    '$route'() {
      this.hasToolbar = false;
    }
  },

}
</script>
